var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 21,
    viewBox: "0 0 6 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.02192 20.0178C6.02309 19.0415 6.02309 17.4585 5.02192 16.4822C4.02076 15.5059 2.39754 15.5059 1.39638 16.4822C0.395217 17.4585 0.395217 19.0415 1.39638 20.0178C2.3975 20.9941 4.02072 20.9941 5.02192 20.0178Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02192 12.5178C6.02309 11.5415 6.02309 9.95855 5.02192 8.98225C4.02076 8.00594 2.39754 8.00594 1.39638 8.98225C0.395217 9.95855 0.395217 11.5415 1.39638 12.5178C2.3975 13.4941 4.02072 13.4941 5.02192 12.5178Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02192 5.01777C6.02309 4.04146 6.02309 2.45855 5.02192 1.48224C4.02076 0.505935 2.39754 0.505935 1.39638 1.48224C0.395217 2.45855 0.395217 4.04146 1.39638 5.01777C2.3975 5.99408 4.02072 5.99408 5.02192 5.01777Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.8ca652a76e14b1b209b4829413448a7e.svg";
export { ForwardRef as ReactComponent };